<template>
  <div ref="loginRoot" class="login-root">
    <div class="digits">
      <input
        type="number"
        maxlength="1"
        pattern="[0-9]"
        inputmode="numeric"
        required
        ref="inputDigit1"
        v-model="digit1"
        v-on:keyup="onKeyUp(1)"
      />
      <input
        type="number"
        maxlength="1"
        pattern="[0-9]"
        inputmode="numeric"
        required
        ref="inputDigit2"
        v-model="digit2"
        v-on:keyup="onKeyUp(2)"
      />
      <input
        type="number"
        maxlength="1"
        pattern="[0-9]"
        inputmode="numeric"
        required
        ref="inputDigit3"
        v-model="digit3"
        v-on:keyup="onKeyUp(3)"
      />
      <input
        type="number"
        maxlength="1"
        pattern="[0-9]"
        inputmode="numeric"
        required
        ref="inputDigit4"
        v-model="digit4"
        v-on:keyup="onKeyUp(4)"
      />
    </div>
    <div class="text">{{$t('loginHelp')}}</div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    digit1: '',
    digit2: '',
    digit3: '',
    digit4: ''
  }),
  mounted() {
    this.$nextTick(() => {
      // Better to wait the next tick for a focus change
      this.$refs.inputDigit1.focus()
    })
  },
  methods: {
    onKeyUp(digitIndex) {
      this.$nextTick(() => {
        // Better to wait the next tick for a focus change AND we want to be sure that the model binding is complete
        const inputDigits = [
          this.$refs.inputDigit1,
          this.$refs.inputDigit2,
          this.$refs.inputDigit3,
          this.$refs.inputDigit4
        ]

        const digits = [this.digit1, this.digit2, this.digit3, this.digit4]

        if (
          digitIndex < inputDigits.length &&
          digits[digitIndex - 1].length === 1
        ) {
          this.$refs.loginRoot.classList.remove('shake') // Otherwise there is no shake on the second error

          inputDigits[digitIndex].focus()
        } else if (
          this.digit1.length === 1 &&
          this.digit2.length === 1 &&
          this.digit3.length === 1 &&
          this.digit4.length === 1
        ) {
          const deviceCode =
            this.digit1 + this.digit2 + this.digit3 + this.digit4
          this.$emit('code-set', deviceCode)
        }
      })
    },

    resetCode() {
      this.digit1 = ''
      this.digit2 = ''
      this.digit3 = ''
      this.digit4 = ''

      this.$refs.inputDigit1.focus()
      this.$refs.loginRoot.classList.add('shake')
    }
  }
}
</script>

<style lang="less">
@import '../app.less';

.login-root {
  background-image: linear-gradient(180deg, lightgray 0%, white 100%);

  .digits {
    display: flex;
    justify-content: center;

    input {
      font-size: @bigger-size;
      width: 3rem;
      text-align: center;
      border: @dark-color 1px solid;
      margin: 1rem;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none; // Remove the up/down arrows in the input field
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield; // Remove the up/down arrows in the input field
    }
  }

  .text {
    text-align: center;
    font-size: @smaller-size;
  }
}

.login-root.shake {
  animation: horizontal-shake 0.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue